module.exports = __webpack_public_path__ + "static/img/kc07.6e23440.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kc07.png
// module id = cZ95
// module chunks = 1